import { render } from "./Team_post_investment_en.vue?vue&type=template&id=6c16fca9&scoped=true"
import script from "./Team_post_investment_en.vue?vue&type=script&lang=js"
export * from "./Team_post_investment_en.vue?vue&type=script&lang=js"

import "./Team_post_investment_en.vue?vue&type=style&index=0&id=6c16fca9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c16fca9"

export default script